import { Component } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { CalendarModal, CalendarModalOptions, CalendarResult, DayConfig } from "ion2-calendar";
import { AdvancedBookingsTimePage } from "../advanced-bookings-time/advanced-bookings-time";
import moment from 'moment';
import { HttpClient } from "@angular/common/http";
import { ApiErrorHandlerProvider } from "../../providers/api-error-handler/api-error-handler";
import { TabsServiceProvider } from "../../providers/tabs-service/tabs-service";
import _ from 'lodash';

@Component({
    selector: 'page-advanced-bookings',
    templateUrl: 'advanced-bookings.html',
})
export class AdvancedBookingsPage {

    shop: any;
    barbers: any;
    allBarbers: any;
    errors: {};
    loading: boolean;
    bookingDate: any;
    hasSelectedBookingDate: boolean = false;
    lastBookingDate: any;
    firstBookingDate: any;
    barber: any;
    byStaff: boolean;
    allowDateSelection: boolean = true;
    guestUser: any = null;
    dateSelected: boolean = false;
    private fromLobby: boolean;
    holidayList: any[] = [];

    constructor(
        private statusBar: StatusBar,
        public navCtrl: NavController,
        public navParams: NavParams,
        public modalCtrl: ModalController,
        private http: HttpClient,
        private apiErrorHandler: ApiErrorHandlerProvider,
        private tabsProvider: TabsServiceProvider
    ) {
        this.shop = navParams.get('shop');
        this.barber = navParams.get('barber');
        this.byStaff = navParams.get('byStaff');
        this.bookingDate = 'Select a Date';
        this.guestUser = navParams.get('guestUser');
        this.fromLobby = navParams.get('fromLobby') ? true : false;
        // Only set the value if it is defined, we want to use the default value if not set
        if (typeof navParams.get('allowDateSelection') !== 'undefined') {
            this.allowDateSelection = navParams.get('allowDateSelection');
        }

        this.filterBarbersByAvailability('');
        this.getLastBookingDate();
        this.getFirstBookingDate();
    }

    ionViewDidLoad() {
        if (this.byStaff && this.barber) {
            this.openBarberAvailabilityCalendar(this.barber);
        }
    }

    ionViewWillEnter() {
        this.tabsProvider.hide();
    }

    doesAllowDateSelection() {
        if (this.allowDateSelection === true) return true;
        return false;
    }

    getLastBookingDate() {
        let daysBookingCanBeMadeInAdvance = this.shop.settings ? this.shop.settings.num_days_bookings_can_be_made_in_advance : 7;
        this.lastBookingDate = moment().add(daysBookingCanBeMadeInAdvance, 'days');
        this.lastBookingDate = new Date(this.lastBookingDate.get('year'), this.lastBookingDate.get('month'), this.lastBookingDate.get('date'));
    }

    getFirstBookingDate() {
        let date = moment(this.shop.first_advanced_booking_date, 'YYYY-MM-DD');
        this.firstBookingDate = new Date(date.get('year'), date.get('month'), date.get('date'));
    }

    isWorkingDay(barberData, date) {
        const weekday = date.getDay();
        if (!barberData.enabledWeekdays.find(i => i === weekday)) {
            return false;
        }

        return !barberData.holidays.find(i => i.getTime() === date.getTime())
    }

    openCalendar() {
        this.setLightStatusBar();
        let disableWeeks = [0, 1, 2, 3, 4, 5, 6];
        let enabledDays = [];
        const barbersData = [];
        const allHolidays = [];

        // Combine the enabled days and holidays of multiple barbers
        this.allBarbers.forEach(barber => {
            let holidays = this.daysConfig(barber);
            let enabledDaysInAWeek = this.enabledDaysInAWeek(barber);

            barbersData.push({
                holidays: holidays.map(i => i.date),
                enabledWeekdays: enabledDaysInAWeek,
            });
            for (const h of holidays) {
                if (!allHolidays.find(i => i.date.getTime() === h.date.getTime())) {
                    allHolidays.push(h);
                }
            }

            enabledDaysInAWeek.forEach((day, index) => {
                enabledDays.push(day);
            });
        });

        const allTeamHolidays = [];
        for (const h of allHolidays) {
            const anyBarberAvailable = barbersData.find(i => this.isWorkingDay(i, h.date));
            if (!anyBarberAvailable) allTeamHolidays.push(h)
        }

        let options = this.options(this.holidayList, disableWeeks);
        // let options = this.options(allTeamHolidays, disableWeeks);
        let myCalendar = this.myCalendar(options);

        // Remove enabled days from the days to disable in the calendar
        enabledDays.forEach((day) => {
            // @ts-ignore
            if (disableWeeks.includes(day)) {
                let index = disableWeeks.indexOf(day);
                if (index !== -1) disableWeeks.splice(index, 1);
            }
        });
        myCalendar.present();

        myCalendar.onDidDismiss((date: CalendarResult, type: string) => {
            this.setDefaultStatusBar();
            if (date) {
                this.bookingDate = moment(date.string, 'YYYY-MM-DD').format('DD/MM/YYYY');
                this.hasSelectedBookingDate = true;
                this.filterBarbersByAvailability(this.bookingDate);
                this.dateSelected = true;
            }
        })
    }

    openBarberAvailabilityCalendar(barber) {
        // If the bookingDate is already set then we don't need to select
        // the date again and we can continue onto the time picker.
        if (this.hasSelectedBookingDate) {
            this.showAdvancedBookingTimes(barber);
            return;
        }
        this.setLightStatusBar();

        let options = this.options(this.daysConfig(barber), this.disableWeeks(barber));
        let myCalendar = this.myCalendar(options);

        myCalendar.present();

        myCalendar.onDidDismiss((date: CalendarResult, type: string) => {
            this.setDefaultStatusBar();
            if (date) {
                this.bookingDate = moment(date.string, 'YYYY-MM-DD').format('DD/MM/YYYY');
                this.showAdvancedBookingTimes(barber);
            }
        })
    }

    filterBarbersByAvailability(date) {
        this.loading = true;

        this.http.get(`/teams/${this.shop.id}/staff?`, {
            params: {
                'has_advanced_booking_date': date
            }
        })
            .subscribe((barbers: any) => {
                this.barbers = barbers;
                if (!this.allBarbers || !date) {
                    this.allBarbers = barbers;
                    this.getAllbarberHoliday();
                }
                this.loading = false;
            }, error => {
                this.loading = false;
                this.errors = this.apiErrorHandler.handleError(error);
            }, () => {

            });
    }

    showBarber(barber) {
        if (!this.barber) return true;

        if (this.barber.id === barber.id) {
            return true;
        }

        return false;
    }

    showAdvancedBookingTimes(barber) {
        this.navCtrl.push(AdvancedBookingsTimePage, {
            date: this.bookingDate,
            shop: this.shop,
            barber: barber,
            byStaff: this.byStaff,
            guestUser: this.guestUser,
            fromLobby: this.fromLobby
        });
    }

    daysConfig(barber) {
        let daysConfig: DayConfig[] = [];

        // Iterate over the barbers holiday and disable all unavailable dates
        if (barber.holiday) {
            barber.holiday.forEach(holiday => {
                holiday.dates.forEach(holidayDate => {

                    let date = moment(holidayDate, 'DD-MM-YYYY');
                    daysConfig.push({
                        date: new Date(date.get('year'), date.get('month'), date.get('date')),
                        marked: false,
                        disable: true
                    });

                });
            });
        }

        return daysConfig;
    }

    disableWeeks(barber) {
        // Disable advanced booking working days
        let disableWeeks: any = [];

        if (Array.isArray(barber.advanced_booking_hours)) {
            barber.advanced_booking_hours = barber.advanced_booking_hours[0];
        }

        if (!barber.advanced_booking_hours.monday) disableWeeks.push(1);
        if (!barber.advanced_booking_hours.tuesday) disableWeeks.push(2);
        if (!barber.advanced_booking_hours.wednesday) disableWeeks.push(3);
        if (!barber.advanced_booking_hours.thursday) disableWeeks.push(4);
        if (!barber.advanced_booking_hours.friday) disableWeeks.push(5);
        if (!barber.advanced_booking_hours.saturday) disableWeeks.push(6);
        if (!barber.advanced_booking_hours.sunday) disableWeeks.push(0);

        return disableWeeks;
    }

    enabledDaysInAWeek(barber) {
        let enabledDays: any = [];

        if (Array.isArray(barber.advanced_booking_hours)) {
            barber.advanced_booking_hours = barber.advanced_booking_hours[0];
        }

        if (barber.advanced_booking_hours.monday && (this.shop && this.shop.hours['monday'])) enabledDays.push(1);
        if (barber.advanced_booking_hours.tuesday && (this.shop && this.shop.hours['tuesday'])) enabledDays.push(2);
        if (barber.advanced_booking_hours.wednesday && (this.shop && this.shop.hours['wednesday'])) enabledDays.push(3);
        if (barber.advanced_booking_hours.thursday && (this.shop && this.shop.hours['thursday'])) enabledDays.push(4);
        if (barber.advanced_booking_hours.friday && (this.shop && this.shop.hours['friday'])) enabledDays.push(5);
        if (barber.advanced_booking_hours.saturday && (this.shop && this.shop.hours['saturday'])) enabledDays.push(6);
        if (barber.advanced_booking_hours.sunday && (this.shop && this.shop.hours['sunday'])) enabledDays.push(0);

        return enabledDays;
    }

    options(daysConfig, disableWeeks) {
        let options: CalendarModalOptions = {
            title: "Select Booking Date",
            monthFormat: "MMMM YYYY",
            closeLabel: "Cancel",
            doneLabel: "Next",
            daysConfig: daysConfig,
            disableWeeks: disableWeeks,
            autoDone: true
        };

        // Prevent user from booking too far in advance i.e. respect the team setting
        if (this.lastBookingDate) options.to = this.lastBookingDate;
        if (this.firstBookingDate) options.from = this.firstBookingDate;

        return options;
    }

    myCalendar(options) {
        return this.modalCtrl.create(CalendarModal, {
            options: options
        }, { cssClass: 'calendar-modal' });
    }
    private setLightStatusBar(): void {
        this.statusBar.backgroundColorByHexString('#2a1e5c');
        this.statusBar.styleLightContent();
    }
    private setDefaultStatusBar(): void {
        this.statusBar.styleDefault();
        this.statusBar.backgroundColorByHexString("#FFFFFF");
    }


    getAllbarberHoliday() {
        const commonDates: string[] = [];
        // iterate through each holiday object
        for (const holidayObj of this.allBarbers) {
            // iterate through each date in the current holiday object
            for (const dateObj of holidayObj.holiday) {
                const currentDate = dateObj.dates[0]; // extract the date string from the date object

                // check if the current date is already in the commonDates array
                //@ts-ignore
                if (commonDates.includes(currentDate)) {
                    // date already exists, do nothing
                } else {
                    // date doesn't exist, check if it appears in all the holiday objects
                    let appearsInAllHolidays = true;
                    for (const otherHolidayObj of this.allBarbers) {
                        if (!otherHolidayObj.holiday.some(otherDateObj => otherDateObj.dates.includes(currentDate))) {
                            appearsInAllHolidays = false;
                            break;
                        }
                    }

                    if (appearsInAllHolidays) {
                        commonDates.push(currentDate);
                    }
                }
            }
        }

        commonDates.forEach(element => {
            let date = moment(element, 'DD/MM/YYYY');
            this.holidayList.push({
                date: new Date(date.get('year'), date.get('month'), date.get('date')),
                marked: false,
                disable: true
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/advanced-bookings/advanced-bookings.ts